interface OperatorStepMarkerProps {
  content: string;
}

/** The "recorded to procedure" marker — pinned and visually distinct from both the agent's
 * own turns and system notices, since it's the emerging artifact of the interview (the SOP
 * being taught), not narration. `content` already carries its own checkmark
 * (see `recordedStepLine` in operatorActivityToChat.ts), so no extra icon here. */
export function OperatorStepMarker({ content }: OperatorStepMarkerProps) {
  return (
    <div className="self-start rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400">
      {content}
    </div>
  );
}
